import React from 'react';
import { Icon } from '@iconify/react';

const MeterReadingsDataTable = ({
  readings,
  onEdit,
  onDelete,
  loading,
  sortField,
  sortOrder,
  onSort,
}) => {
  const renderSortIcon = (field) => {
    if (sortField !== field) return <Icon icon="mdi:unfold-more-horizontal" className="ms-1 text-muted" />;
    return sortOrder === 'ASC'
      ? <Icon icon="mdi:arrow-up" className="ms-1" />
      : <Icon icon="mdi:arrow-down" className="ms-1" />;
  };

  const sortableHeader = (label, field, className = '') => (
    <th className={className}>
      <button
        type="button"
        className="btn btn-link p-0 d-inline-flex align-items-center text-decoration-none text-dark"
        onClick={() => onSort(field)}
      >
        {label}
        {renderSortIcon(field)}
      </button>
    </th>
  );

  return (
    <table className="table bordered-table mb-3" style={{ width: '100%', borderRadius: '0' }}>
      <thead>
        <tr>
          {sortableHeader('Date', 'date', 'rounded-0')}
          {sortableHeader('Asset Start Date', 'asset.startDate')}
          {sortableHeader('Value', 'value')}
          {sortableHeader('Meter', 'meter')}
          {sortableHeader('Asset', 'asset', 'rounded-0')}
          <th>Invalid</th>
          <th style={{ borderRadius: '0' }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {readings.map((r) => (
          <tr key={r.id}>
            <td>{r.readingDate ? r.readingDate.slice(0, 16).replace('T', ' ') : ''}</td>
            <td>{r.asset.assetStartDate}</td>
            <td>{r.value}</td>
            <td>{r.meters?.name || ''}</td>
            <td>{r.asset ? `${r.asset.assetNumber} | ${r.asset.assetDescription}` : ''}</td>
            <td>
              <div className="form-switch switch-primary d-flex">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={!!r?.invalid}
                  readOnly
                />
              </div>
            </td>
            <td>
              <button
                className="edit-btn w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center mx-6"
                onClick={() => onEdit(r)}
              >
                <Icon icon="ic:baseline-edit" />
              </button>
              <button
                className="delete-btn w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                onClick={() => onDelete(r.id)}
              >
                <Icon icon="ic:baseline-delete-outline" />
              </button>
            </td>
          </tr>
        ))}
        {!loading && readings.length === 0 && (
          <tr>
            <td colSpan={5} className="text-center py-2">
              No Meter Readings items found
            </td>
          </tr>
        )}
        {loading && (
          <tr>
            <td colSpan="5" className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default MeterReadingsDataTable;
